import { Component, Host, Prop, h } from '@stencil/core';
import clsx from 'clsx';
import {
  TypographyTag,
  TypographyVariant,
  TypographyTextAlign,
} from './md-typography.types';
import { TypographyColor } from '../../../../../shared-assets/utils/PropTypes';

/**
 * Used for adding typography in any of the Antiqua's supported variants.
 * Check figma <a href="https://www.figma.com/design/X4B9kN0qCP6rPWZoO7h5La/Antiqua-DLS-Guide-v1.0?node-id=1219-26844&t=frp7UWAkpg5aub4V-0" target="_blank">here</a>
 */
@Component({
  tag: 'md-typography',
  styleUrl: 'md-typography.css',
  shadow: true,
})
export class MdTypography {
  /**
   * Tag to be used.
   */
  @Prop() tag: TypographyTag = 'div';

  /**
   * Add textdecoration styling to typography.
   */

  @Prop() textdecoration: 'none' | 'underline' | 'line-through' = 'none';

  /**
   * Add CSS text-align styling
   */
  @Prop() textalign: TypographyTextAlign = 'start';

  /**
   * Color to be used for typography.
   */
  @Prop() color: TypographyColor = 'spirits--900';

  /**
   * Typography variant to be used.
   */
  @Prop() variant: TypographyVariant = 'body1--regular';

  /**
   * Responsive typography
   */
  @Prop() responsive = true;

  /**
   * Add CSS text-wrap styling
   */
  @Prop() nowrap = false;

  render() {
    const Tag = this.tag;
    return (
      <Host
        class={{
          [`md-display--${this.tag}`]: true,
          'md-responsive': this.responsive,
        }}
      >
        <Tag
          class={clsx(
            'md-typography',
            this.color && `is-text-color--${this.color}`,
            this.variant && `is-typography-variant--${this.variant}`,
            this.textalign && `is-textalign--${this.textalign}`,
            this.nowrap && 'is-nowrap',
            this.textdecoration &&
              this.textdecoration !== 'none' &&
              `is-textdecoration--${this.textdecoration}`,
          )}
          part="md-typography"
        >
          {/**
           * Default slot for `md-typography` component.
           *
           * Insert the text or other content that you want to apply typography to.
           * The inserted content will be styled according to the `variant`, `color`,
           * `textalign`, and `textdecoration` props.
           */}
          <slot />
        </Tag>
      </Host>
    );
  }
}
